import { render, staticRenderFns } from "./rh_colaborador.vue?vue&type=template&id=6ff06234&scoped=true&"
import script from "./rh_colaborador.vue?vue&type=script&lang=js&"
export * from "./rh_colaborador.vue?vue&type=script&lang=js&"
import style0 from "./rh_colaborador.vue?vue&type=style&index=0&id=6ff06234&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff06234",
  null
  
)

export default component.exports